import * as React from "react";

function SvgAvatar16(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 55 55" {...props}>
      <defs>
        <rect
          id="avatar_(16)_svg__a"
          x={0}
          y={0}
          width={55}
          height={55}
          rx={15}
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="avatar_(16)_svg__b" fill="#fff">
          <use xlinkHref="#avatar_(16)_svg__a" />
        </mask>
        <use fill="#6CD0B7" opacity={0.49} xlinkHref="#avatar_(16)_svg__a" />
        <g fillRule="nonzero" mask="url(#avatar_(16)_svg__b)">
          <path
            d="M15.873 11.893c-2.498 3.853-3.168 8.666-2.33 13.142.837 4.475 3.07 8.626 5.96 12.222 2.54-.65 5.262-.068 7.216 1.636 1.633-.757 2.093-2.596 2.247-4.34.21-2.34.419-4.719-.042-7.03-.67-3.394-2.722-6.369-4.927-9.086-2.22-2.758-4.718-5.408-8.124-6.544z"
            fill="#463B3B"
          />
          <path
            d="M38.527 11.893c2.498 3.853 3.168 8.666 2.33 13.142-.837 4.475-3.07 8.626-5.96 12.222-2.54-.65-5.262-.068-7.216 1.636-1.633-.757-2.093-2.596-2.247-4.34-.21-2.34-.419-4.719.042-7.03.67-3.394 2.722-6.369 4.927-9.086 2.22-2.758 4.718-5.408 8.124-6.544z"
            fill="#463B3B"
          />
          <path
            d="M32.234 38.26h.002l-1.448-4.507-3.808-.282-.74.055 3.067.227 1.448 4.507h-.002a.571.571 0 01.035.188c0 .853-1.98 1.556-4.548 1.672.242.01.488.018.74.018 2.92 0 5.289-.756 5.289-1.69a.57.57 0 00-.035-.188z"
            fill="#D9BFB8"
          />
          <path
            d="M32.234 38.26h.002l-1.448-4.507-3.808-.282-3.808.282-1.448 4.507h.002a.571.571 0 00-.034.188c0 .934 2.368 1.69 5.288 1.69 2.92 0 5.289-.756 5.289-1.69a.57.57 0 00-.035-.188z"
            fill="#E6CBC3"
          />
          <path
            d="M27.5 6C25.5 6 15 19.946 15 24.962c1.457 6.029 6.408 10.467 12.293 10.467 6.96 0 12.612-6.206 12.725-13.909C35.5 15.5 29.5 6 27.5 6z"
            fill="#FFE1D9"
          />
          <path
            d="M32.842 29.707c.243.37-2.094 2.463-5.549 2.463-3.455 0-5.792-2.092-5.548-2.463.244-.371 2.601.856 5.548.856s5.306-1.227 5.55-.856z"
            fill="#E6BAAD"
          />
          <g transform="translate(20.293 22)">
            <ellipse fill="#F5F5F5" cx={1.733} cy={1.5} rx={1.733} ry={1.5} />
            <circle fill="#000" cx={1.733} cy={1.5} r={1} />
          </g>
          <g transform="translate(29.826 22)">
            <ellipse fill="#F5F5F5" cx={1.733} cy={1.5} rx={1.733} ry={1.5} />
            <circle fill="#000" cx={1.733} cy={1.5} r={1} />
          </g>
          <path
            d="M41.623 16.498c-.686-3.56-2.567-6.97-5.551-9.16-2.487-1.821-5.807-2.711-8.871-2.19-3.051-.521-6.371.369-8.871 2.19-2.984 2.177-4.866 5.586-5.551 9.16-.686 3.56.175 7.024 1.223 10.502 3.71-1.821 6.37-5.422 6.693-9.448H33.72c.322 4.04 2.97 7.627 6.693 9.448 1.022-3.478 1.895-6.942 1.21-10.502z"
            fill="#5A4B4B"
          />
          <g>
            <path
              d="M46.833 47.76c-1.937-9.738-16.463-8.468-19.853-8.468-3.39 0-17.916-1.27-19.852 8.467-1.937 9.737 7.747 13.124 7.747 13.124h24.21s9.684-3.387 7.748-13.124z"
              fill="#CFCFCF"
            />
            <path
              d="M21.5 38.869c-2.667.087-6.051.652-10.154 1.693C7.244 41.603 3.962 45.416 1.5 52L5 63h22v-9.337l-1.25-1.67-4.25-13.124zM32.5 39c2.667.088 6.051.652 10.154 1.693 4.102 1.042 7.384 4.854 9.846 11.438l-3.5 11H27v-9.336l1.25-1.67L32.5 39z"
              fill="#F5F5F5"
            />
            <path
              d="M17.27 44.796c.845-.424 4.23-1.694 4.23-1.694l-.423 3.81L27 53.686C24.885 50.3 21.923 38.87 21.923 37.6c-1.92 1.093-4.654 3.527-4.654 7.197zM36.73 44.796c-.845-.424-4.23-1.694-4.23-1.694l.423 3.81L27 53.686C29.115 50.3 32.077 38.87 32.077 37.6c1.92 1.093 4.654 3.527 4.654 7.197z"
              fill="#E6E6E6"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgAvatar16;
